import { render, staticRenderFns } from "./CoilComponent.vue?vue&type=template&id=822fff18&"
import script from "./CoilComponent.vue?vue&type=script&lang=js&"
export * from "./CoilComponent.vue?vue&type=script&lang=js&"
import style0 from "./CoilComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports